// markdownMiniParser mini版markdown解析器

const STYLE_CONFIG = {
	'h1': 'margin-block-start: 0.5em;margin-block-end: 0.5em;', // [font-size] 2.00em  [margin-block-start、margin-block-end] 0.67em
	'h2': 'margin-block-start: 0.5em;margin-block-end: 0.5em;', // [font-size] 1.50em  [margin-block-start、margin-block-end] 0.83em
	'h3': 'margin-block-start: 0.5em;margin-block-end: 0.5em;', // [font-size] 1.17em  [margin-block-start、margin-block-end] 1.00em
	'h4': 'margin-block-start: 0.5em;margin-block-end: 0.5em;', // [font-size] 1.00em  [margin-block-start、margin-block-end] 1.33em
	'h5': 'margin-block-start: 0.5em;margin-block-end: 0.5em;', // [font-size] 0.83em  [margin-block-start、margin-block-end] 1.67em
	'h6': 'margin-block-start: 0.5em;margin-block-end: 0.5em;', // [font-size] 0.67em  [margin-block-start、margin-block-end] 2.33em
	'img': 'width: 100%;font-size: 0;'
};

// 获取样式
function getStyleByLabel(lable, styleConfig) {
	return styleConfig[lable] ? styleConfig[lable] : '';
}

// html转义
function escapeHtml(text) {
	return text.replace(/[&<>"']/g, function(match) {
		switch(match) {
			case '&':
				return '&amp;';
			case '<':
				return '&lt;';
			case '>':
				return '&gt;';
			case '"':
				return '&quot;';
			case '\'':
				return '&#39;';
		}
	});
}


export default function(text = '', styleConfig = STYLE_CONFIG) {
	if (text === '') {
		return text;
	}
	let html = '';
	const lines = text.split('\n').map(item => item.trimStart());
	styleConfig = (typeof styleConfig === 'object' && Array.isArray(styleConfig) === false) ? styleConfig : STYLE_CONFIG;
	for (let line of lines) {
		// 处理标题
		if (line.startsWith('#')) {
			let level = line.match(/^#+/)[0].length;
			let title = line.substring(level).trim();
			let label = 'h' + level;
			let style = getStyleByLabel(label, styleConfig);
			html += `<${label} style="${style}">${title}</${label}>`;
		}
		// 处理无序列表
		else if (line.startsWith('* ')) {
			let text = line.substring(2).trim();
			let label = 'li';
			let style = getStyleByLabel(label, styleConfig);
			html += `<${label} style="${style}">${text}</${label}>`;
		}
		// 处理有序列表
		else if (/^\d+\.\s/.test(line)) {
			let text = line.substring(line.indexOf('.') + 1).trim();
			let label = 'li';
			let style = getStyleByLabel(label, styleConfig);
			html += `<${label} style="${style}">${text}</${label}>`;
		}
		// 处理分割线
		else if (/^[\*|\-|\_]{3,}/.test(line)) {
			html += line.replace(/^[\*|\-|\_]{3,}/, '<hr/>');
		}
		// 处理加粗
		else if (line.startsWith('**') || line.startsWith('__')) {
			let label = 'strong';
			let style = getStyleByLabel(label, styleConfig);
			html += line.replace(line.startsWith('**') ? /\*\*(.*)\*\*/gm : /__(.*)__/gm, `<${label} style="${style}">$1</${label}>`);
		}
		// 处理斜体
		else if (line.startsWith('*') || line.startsWith('_')) {
			let label = 'em';
			let style = getStyleByLabel(label, styleConfig);
			html += line.replace(line.startsWith('*') ? /\*(.*)\*/gm : /_(.*)_/gm, `<${label} style="${style}">$1</${label}>`);
		}
		// 处理删除线
		else if (line.startsWith('~~')) {
			let label = 'del';
			let style = getStyleByLabel(label, styleConfig);
			html += line.replace(/~~(.*)~~/gm, `<${label} style="${style}">$1</${label}>`);
		}
		// 处理超链接
		else if (line.startsWith('[')) {
			let label = 'a';
			let style = getStyleByLabel(label, styleConfig);
			html += line.replace(/\[(.*?)\]\((.*?)\)/gm, `<${label} style="${style}" href="$2">$1</${label}>`);
		}
		// 处理图片
		else if (line.startsWith('![')) {
			let label = 'img';
			let style = getStyleByLabel(label, styleConfig);
			html += line.replace(/!\[(.*?)\]\((.*?)\)/gm, `<${label} src="$2" alt="$1" style="${style}" />`);
		}
		// 处理行内代码
		else if (line.startsWith('`')) {
			let label = 'code';
			let style = getStyleByLabel(label, styleConfig);
			html += escapeHtml(line).replace(/`(.*?)`/gm, `<${label} style="${style}">$1</${label}>`);
		}
		// 处理段落
		else {
			if (line.length) {
				let label = 'p';
				let style = getStyleByLabel(label, styleConfig);
				html += `<${label} style="${style}">${line}</${label}>`;
			} else {
				html += `<br/>`;
			}
		}
	}
	// 包装HTML代码
	return `<div>${html}</div>`;
}